import ScrolledDropdown, { TogglerWithFloatLabel } from "Components/scrolledDropdown";
import classNames from "classnames";
import map from "lodash/map";
import toNumber from "lodash/toNumber";
import React, { memo, useCallback, useEffect, useState } from "react";
import locale from "../taskStatisticsFilter.locale";
const keySelector = (item) => `${item.Id}`;
const textSelector = (item) => `${item.Name}`;
function UsersFilter({ className, userIds, users, isCleared, onApplyFilter }) {
    const [selectedUsersIds, setSelectedUsersIds] = useState([]);
    const handleUsersChange = useCallback((usersIds) => {
        setSelectedUsersIds(usersIds);
    }, []);
    useEffect(() => {
        if (!userIds) {
            setSelectedUsersIds([]);
        }
        else {
            const ids = map(userIds, (el) => String(el));
            setSelectedUsersIds(ids);
        }
    }, [userIds, isCleared]);
    const handleApplyUsersFilter = useCallback(() => {
        onApplyFilter({
            userId: selectedUsersIds.length
                ? map(selectedUsersIds, (el) => toNumber(el))
                : undefined
        });
    }, [selectedUsersIds, onApplyFilter]);
    const handleCancelUsersFilter = useCallback(() => {
        const ids = (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? map(userIds, id => String(id)) : [];
        setSelectedUsersIds(ids);
    }, [selectedUsersIds, onApplyFilter]);
    return (React.createElement(ScrolledDropdown, { className: classNames(className, "dropdown-toggle-flex-space-between"), items: users, keySelector: keySelector, textSelector: textSelector, onSelectedMultiChanged: handleUsersChange, showSearchInputWhenItemsLengthIsGreaterThan: -1, selectedKey: selectedUsersIds, multi: true, withApplyButton: true, onApply: handleApplyUsersFilter, onCancel: handleCancelUsersFilter, togglerComponent: React.createElement(TogglerWithFloatLabel, null), caption: "", label: locale.AUTHOR, togglerHeight: 44, popoverWidth: 300, maxWidth: 250, width: 250 }));
}
export default memo(UsersFilter);
